// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let JsxRuntime = require("react/jsx-runtime");
let PropertyAttributes = require("./PropertyAttributes.bs.js");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let DevelopmentSampleUnitBeds = require("../Development/DevelopmentSampleUnitBeds.bs.js");
let DevelopmentSampleUnitBaths = require("../Development/DevelopmentSampleUnitBaths.bs.js");
let DevelopmentSampleUnitSummary = require("../Development/DevelopmentSampleUnitSummary.bs.js");
let DevelopmentSampleUnitSquareFeet = require("../Development/DevelopmentSampleUnitSquareFeet.bs.js");
let DevelopmentUnitSearchResultAttributes_newDevelopmentSampleUnit_graphql = require("../../../__generated__/DevelopmentUnitSearchResultAttributes_newDevelopmentSampleUnit_graphql.bs.js");

let convertFragment = DevelopmentUnitSearchResultAttributes_newDevelopmentSampleUnit_graphql.Internal.convertFragment;

function DevelopmentUnitSearchResultAttributes(props) {
  let unit = RescriptRelay_Fragment.useFragment(DevelopmentUnitSearchResultAttributes_newDevelopmentSampleUnit_graphql.node, convertFragment, props.unit);
  let match = unit.beds;
  let bedsState;
  if (match !== undefined) {
    switch (match.__typename) {
      case "DevelopmentProjectUnitBedsRange" :
        bedsState = DevelopmentSampleUnitBeds.range(match.minBeds, match.maxBeds);
        break;
      case "DevelopmentProjectUnitExactBeds" :
        bedsState = DevelopmentSampleUnitBeds.exact(match.beds);
        break;
      case "__unselected" :
        bedsState = DevelopmentSampleUnitBeds.empty;
        break;
    }
  } else {
    bedsState = DevelopmentSampleUnitBeds.empty;
  }
  let match$1 = unit.baths;
  let bathsState;
  if (match$1 !== undefined) {
    switch (match$1.__typename) {
      case "DevelopmentProjectUnitBathsRange" :
        bathsState = DevelopmentSampleUnitBaths.range(match$1.minBaths, match$1.maxBaths);
        break;
      case "DevelopmentProjectUnitExactBaths" :
        bathsState = DevelopmentSampleUnitBaths.exact(match$1.baths);
        break;
      case "__unselected" :
        bathsState = DevelopmentSampleUnitBaths.empty;
        break;
    }
  } else {
    bathsState = DevelopmentSampleUnitBaths.empty;
  }
  let match$2 = unit.squareFeet;
  let squareFeetState;
  if (match$2 !== undefined) {
    switch (match$2.__typename) {
      case "DevelopmentProjectUnitExactSquareFeet" :
        squareFeetState = DevelopmentSampleUnitSquareFeet.exact(match$2.squareFeet);
        break;
      case "DevelopmentProjectUnitSquareFeetRange" :
        squareFeetState = DevelopmentSampleUnitSquareFeet.range(match$2.minSquareFeet, match$2.maxSquareFeet);
        break;
      case "__unselected" :
        squareFeetState = DevelopmentSampleUnitSquareFeet.empty;
        break;
    }
  } else {
    squareFeetState = DevelopmentSampleUnitSquareFeet.empty;
  }
  let propertyAttributes = DevelopmentSampleUnitSummary.propertyAttributes(bedsState.bedsRange, bedsState.beds, bedsState.minBeds, bedsState.maxBeds, bathsState.bathsRange, bathsState.baths, bathsState.minBaths, bathsState.maxBaths, squareFeetState.squareFeetRange, squareFeetState.squareFeet, squareFeetState.minSquareFeet, squareFeetState.maxSquareFeet);
  if (propertyAttributes !== 0) {
    return JsxRuntime.jsx(PropertyAttributes.make, {
      propertyAttributes: propertyAttributes,
      size: "sm"
    });
  } else {
    return null;
  }
}

let make = DevelopmentUnitSearchResultAttributes;

exports.make = make;
/* react/jsx-runtime Not a pure module */
